export const TC_Section ={
        Internet:"TOGGLE_INTERNET_ACCOR",
        Router:"TOGGLE_INTERNET_ROUTER_ACCOR",
        TV:"TOGGLE_TV_ACCOR",
        Router_TV:"TOGGLE_TV_ROUTER_ACCOR",
        Equip:"TOGGLE_TV_SETTOPBOX_ACCOR",
        Recording:"TOGGLE_TV_RECORDING_ACCOR",
        Channel:"TOGGLE_TV_CUSTOMTV_ACCOR",
        PremiumChnl:"TOGGLE_TV_CHANNEL_ACCOR",
        Voice:"TOGGLE_PHONE_ACCOR",
        Directory:"TOGGLE_PHONE_LISTING_ACCOR",
        BatterBkup:"TOGGLE_PHONE_BACKUP_ACCOR",
        ContactInfo:"Checkout_Contact_Info",
        CreditCheck:"Checkout_credit_check",
        CreditCheck_RTA:"Checkout_creditcheck_RTA",
        CreditCheck_Jumio:"Checkout_creditcheck_Jumio",
        CreditCheck_Fail:"Checkout_CreditFail",
        Installation:"Checkout_Installation",
        TOS:"Checkout_TermsOfService",
        Internationalchnl:"TOGGLE_TV_INTERNATIONALCHANNEL_ACCOR"
}
export const touchCommerceID=[
             {
                TCID :"36736082",
                SectionID:"BuildFios_DataPackage",
                SectionName:"TOGGLE_INTERNET_ACCOR",
                ServiceType:"INTERNET",
                TCPageName:"VZT-Ordering-I-Accordion_Order - DataPackage",
                Appid:"NC"
             },
             {
                TCID :"36745138",
                SectionID:"BuildFios_Internet_AddRouter",
                SectionName:"TOGGLE_INTERNET_ROUTER_ACCOR",
                ServiceType:"ROUTER",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_Internet_AddRouter",
                Appid:"NC"
             },
             {
                TCID :"36784352",
                SectionID:"BuildFios_TVPackage",
                SectionName:"TOGGLE_TV_ACCOR",
                ServiceType:"VIDEO",
                TCPageName:"VZT-Ordering-I-Accordion_Order-TVPackage",
                Appid:"NC"
             },
             {
                TCID :"36745138",
                SectionID:"BuildFios_Internet_AddRouter",
                SectionName:"TOGGLE_TV_ROUTER_ACCOR",
                ServiceType:"ROUTER",
                TCPageName:"VZT-Ordering-I-Accordion_Order-TVPackage",
                Appid:"NC"
             },
             {
                TCID :"36745139",
                SectionID:"BuildFios_TV_AddTVEquip",
                SectionName:"TOGGLE_TV_SETTOPBOX_ACCOR",
                ServiceType:"VROOM",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_TV_AddTVEquip",
                Appid:"NC"
             },
             {
                TCID :"36745139",
                SectionID:"BuildFios_TV_AddTVEquip",
                SectionName:"TOGGLE_TV_RECORDING_ACCOR",
                ServiceType:"RECORDING",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_TV_AddTVEquip",
                Appid:"NC"
             },
             {
                TCID :"36745140",
                SectionID:"BuildFios_TV_AddTVChan",
                SectionName:"TOGGLE_TV_CUSTOMTV_ACCOR",
                ServiceType:"CUSTOMTV",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_TV_AddTVChan",
                Appid:"NC"
             },
             {
                TCID :"36745141",
                SectionID:"BuildFios_TV_AddTPremChan",
                SectionName:"TOGGLE_TV_CHANNEL_ACCOR",
                ServiceType:"CHANNEL",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_TV_AddTPremChan",
                Appid:"NC"
             },
             {
                TCID :"36784353",
                SectionID:"BuildFios_VoicePackage",
                SectionName:"TOGGLE_PHONE_ACCOR",
                ServiceType:"FIOS_VOICE",
                TCPageName:"VZT-Ordering-I-Accordion_Order-VoicePackage",
                Appid:"NC"
             },
             {
                TCID :"36745142",
                SectionID:"BuildFios_DigVoice_AddDirectory",
                SectionName:"TOGGLE_PHONE_LISTING_ACCOR",
                ServiceType:"LISTING",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_DigVoice_AddDirectory",
                Appid:"NC"
             },
             {
                TCID :"36745143",
                SectionID:"BuildFios_DigVoice_AddBatteryBackup",
                SectionName:"TOGGLE_PHONE_BACKUP_ACCOR",
                ServiceType:"BATTERY",
                TCPageName:"VZT-Ordering-I-Accordion_BuildFios_DigVoice_AddBatteryBackup",
                Appid:"NC"
             },
             {
                TCID :"36736083",
                SectionID:"Checkout_Contact_Info",
                TCPageName:"VZT-Ordering-I-Accordion_Checkout  Contact Info",
                Appid:"NC"
             },
             {
                TCID :"36784354",
                SectionID:"Checkout_credit_check",
                TCPageName:"VZT-Ordering-I-Accordion_Checkoutcreditcheck",
                Appid:"NC"
             },
             {
                TCID :"36784355",
                SectionID:"Checkout_creditcheck_RTA",
                TCPageName:"VZT-Ordering-I-Accordion_CheckoutcreditcheckRTA",
                Appid:"NC"
             },
             {
                TCID :"36784356",
                SectionID:"Checkout_creditcheck_Jumio",
                TCPageName:"VZT-Ordering-I-Accordion_CheckoutcreditcheckJumjo",
                Appid:"NC"
             },
             {
                TCID :"36745144",
                SectionID:"Checkout_CreditFail",
                TCPageName:"VZT-Ordering-I-Accordion_Checkout_CreditFail",
                Appid:"NC"
             },
             {
                TCID :"36745145",
                SectionID:"Checkout_Installation",
                TCPageName:"VZT-Ordering-I-Accordion_Checkout_Installation",
                Appid:"NC"
             },
             {
                TCID :"36745146",
                SectionID:"Checkout_TermsOfService",
                TCPageName:"VZT-Ordering-I-Accordion_Checkout_TermsOfService",
                Appid:"NC"
             }             
        ]

export const services={
    fiosData:"FIOSDATA",
    fiosTV:"FIOSTV",
    fiosVideo:"VIDEO",
    fiosVoice:"FIOSVOICE",
    voice:"VOICE",
    freedomEssentials:"FREEDOMESSENTIALS"
}
export const orderFlow ={
    fios:"FIOS",
    nonfios:"NON-FIOS"
}